export const cars = {
  // Search
  searchCars: 'Search Cars',
  searchCarsDescription: 'Find the perfect car for your trip',
  location: 'Location',
  selectLocation: 'Select location',
  checkInDate: 'Check-in Date',
  checkOutDate: 'Check-out Date',
  selectDate: 'Select date',
  searchNow: 'Search Now',
  clearAll: 'Clear All',
  optionalDates: 'Optional: Add dates for better results',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  whereGoing: 'Where are you going?',
  whenTrip: 'When is your trip?',
  quickSelect: 'Quick select',
  threeDays: '3 days',
  oneWeek: '1 week',
  twoWeeks: '2 weeks',
  search: 'Search',
  
  // Cars page
  availableCars: 'Available Cars',
  carsCount: '{{count}} car available',
  carsCount_other: '{{count}} cars available',
  noCarsAvailable: 'No cars available at the moment.',
  imageNotAvailable: 'Image not available',
  seats: 'seats',
  automatic: 'Auto',
  manual: 'Manual',
  others: 'others',
  perDay: '/day',
  book: 'Book',
  available: 'Available',
  currency: 'MAD',
  notAvailable: 'N/A',
  insured: 'Insured',
  
  // Error handling
  error: 'Error',
  retry: 'Try Again',
  loadingCars: 'Loading cars...',
  
  // Car listing page
  findPerfectCar: 'Find the perfect car for your next journey',
  searchByMakeModel: 'Search by make or model',
  allCategories: 'All Categories',
  allTransmissions: 'All Transmissions',
  anySeats: 'Any Seats',
  clearFilters: 'Clear Filters',
  carsFound: 'cars found',
  noCarsFound: 'No cars found',
  adjustSearchCriteria: 'Try adjusting your search criteria or clear filters to see more results.',
  more: 'more',
  filters: 'Filters',
  category: 'Category',
  transmission: 'Transmission',
  priceRange: 'Price Range (MAD)',
  minPrice: 'Min',
  maxPrice: 'Max',
  filtered: 'Filtered results',
  
  // Enhanced filters
  allBrands: 'All brands',
  searchBrands: 'Search brands...',
  noBrandsFound: 'No brands found.',
  allModels: 'All models',
  selectBrandFirst: 'Select a brand',
  
  // Car details
  viewDetails: 'View Details',
  specifications: 'Specifications',
  featuresTab: 'Features',
  moreFeatures: 'more features',
  noFeatures: 'No features available',
  description: 'Description',
  gallery: 'Gallery',
  
  // Booking
  selectCar: 'Select Car',
  bookNow: 'Book Now',
  reserveNow: 'Reserve Now',
  pricePerDay: 'per day',
  
  // Reviews
  reviews: 'Reviews',
  writeReview: 'Write a Review',
  rating: 'Rating',
  
  // Car Details Page
  rentalAgency: 'Rental Agency',
  bookThisCar: 'Book This Car',
  locationDetails: 'Pickup & Drop-off Locations',
  dateTimeDetails: 'Dates & Times',
  additionalDetails: 'Additional Information',
  pickupLocation: 'Pickup Location',
  dropoffLocation: 'Drop-off Location',
  pickupTime: 'Pickup Time',
  returnTime: 'Return Time',
  day: 'day',
  days: 'days',
  additionalNotes: 'Additional Notes',
  additionalNotesPlaceholder: 'Enter any additional notes...',
  dailyRate: 'Daily Rate',
  duration: 'Duration',
  total: 'Total',
  processing: 'Processing...',
  needToSignIn: 'You need to sign in',
  toBookThisCar: 'to book this car',
  fuel: 'Fuel',
  
  // Agency Details
  agencyDetails: {
    title: 'Agency Details',
    description: 'Agency details page for ID: {{id}} is under development.',
  },
  
  // Agency filtering
  filterByAgency: 'Filter by Agency',
  browsingAgencyCars: 'Browsing cars from {{agency}}',
  agencyNotFound: 'Agency not found',
  
  // Booking features
  features: {
    cancelAnytime: 'Free cancellation',
    instantConfirmation: 'Instant confirmation',
    flexibleTiming: 'Flexible hours 8am-10pm',
    premiumSupport: '24/7 premium customer support',
    multipleLocations: 'Pickup from multiple cities'
  },

  // Search Panel
  pickupDropoff: 'Pick-up / Drop-off',
  searchLocation: 'Search location...',
  noLocationFound: 'No location found.',
  agency: 'Agency',
  dates: 'Dates',
  pickDate: 'Pick a date',
  notesPlaceholder: 'Any special requests or notes...',
  changeLocation: 'Change location',
  totalPrice: 'Total Price',
  selectPickupLocation: 'Select Pickup Location',
  selectDropoffLocation: 'Select Drop-off Location',
  select: 'Select',
  openInMap: 'Open in Map',
  bookingSuccess: 'Booking Successful!',
  bookingCreatedSuccessfully: 'Your booking has been created successfully!',
  agencyWillContact: 'The agency will contact you via WhatsApp to confirm your reservation.',
  keepPhoneAvailable: 'Please keep your phone available.',
  trackInDashboard: 'You can track your booking in your dashboard',
  goToDashboard: 'Go to Dashboard',
  
  // Category browsing
  browseByCategory: 'Browse by Category',
  browsingCategoryDescription: 'Browse our selection of',
  
  // Availability status
  availabilityStatus: 'Availability',
  allStatuses: 'All Statuses',
  availableStatus: 'Available',
  rented: 'Rented',
  maintenance: 'Maintenance',
  unavailable: 'Unavailable',
  showAll: 'Show All',
  availableOnly: 'Available Only',
  availableOnlySelectedDates: 'Available Only on Selected Dates',
  availableOnlyToday: 'Available Only Today',
  applyFilters: 'Apply Filters',
  nameAZ: 'Name: A-Z',
  
  // Sort options
  sortBy: 'Sort by',
  relevant: 'Relevant',
  newest: 'Newest',
  priceLowHigh: 'Price: Low to High',
  priceHighLow: 'Price: High to Low',
  yearNewest: 'Year: Newest',
  
  // Related cars
  otherCarsSameCategory: 'Other Cars in the Same Category',
  otherCarsSameCity: 'Other Cars in the Same City',
  loadingRelatedCars: 'Loading related cars...',
  noRelatedCars: 'No related cars found'
}; 